/**
 * N-287 · Los opcionales pedidos ({id, name}) frente al catálogo del tramo nuevo, con la regla
 * de N-286 (`BudgetCopyService::opcionalesDelTramo` en el backend): cada uno sigue si su tarifa
 * está; si no, pasa a la del MISMO NOMBRE (el mismo servicio en otro tramo de personas, la de
 * menor id); si no hay ninguna, se cae. La usan el transporte (zona A) y los extras del
 * alojamiento (zona B).
 */
export function opcionalesDelTramo(pedidos: any[], catalogo: any[]): any[] {
	const resultado: any[] = [];
	for (const pedido of pedidos) {
		const nombre = String(pedido.name || '').trim();
		const delCatalogo = catalogo.find((opcion) => opcion.id == pedido.id) || catalogo
			.filter((opcion) => nombre !== '' && String(opcion.name || '').trim() === nombre)
			.sort((a, b) => a.id - b.id)[0];
		if (delCatalogo && !resultado.some((ya) => ya.id == delCatalogo.id)) {
			resultado.push(delCatalogo);
		}
	}
	return resultado;
}

/**
 * N-287 · La regla del funnel (`BudgetService::setBudgetAccommodation`) para una tarifa de
 * alojamiento: cubre si empieza antes o el mismo día que el viaje y acaba después o el mismo
 * día que su fin. Sin fechas (el editor de paquetes) no se filtra por fecha. Las personas ya
 * las filtra el servidor al dar el catálogo.
 */
export function tarifaCubreFechas(tarifa: any, inicio: any, fin: any): boolean {
	if (!inicio || !fin) {
		return true;
	}
	const dia = (fecha) => String(fecha || '').substring(0, 10);
	return dia(tarifa.date_start) <= dia(inicio) && dia(tarifa.date_end) >= dia(fin);
}

/**
 * N-287 B (decisión de Bernardo, 8-oct-2026): a un viaje que ya empezó no se le aplica la regla
 * de la tarifa. Las tarifas se re-fechan con el tiempo y un viaje viejo se quedaría sin ninguna
 * que lo cubra: no se podría corregir un dato. «Empezó» = su llegada es anterior a hoy.
 */
export function viajeYaEmpezado(inicio: any): boolean {
	if (!inicio) {
		return false;
	}
	const ahora = new Date();
	const dos = (n) => (n < 10 ? '0' : '') + n;
	const hoy = ahora.getFullYear() + '-' + dos(ahora.getMonth() + 1) + '-' + dos(ahora.getDate());
	return String(inicio).substring(0, 10) < hoy;
}
